import Api from '@/api/api'


export default {
    getRoster(id,date) {
        return Api.get(`/ETMSAgr/api/Dashboard/GetRostersInfoByDate?facilityID=${id}&inputDate=${date}`);
    },
    getAdhocRequestCount(id,date) {
        return Api.get(`/ETMSAgr/api/Dashboard/GetAdhocRequestCount?facilityID=${id}&inputDate=${date}`);
    },
    getTripProgress(id,fromDate,toDate) {
        return Api.get(`/ETMSAgr/api/Dashboard/GetTripsInProgress?facilityID=${id}&fromDate=${fromDate}&toDate=${toDate}&VendorID=`);
    },
    getUpcomingTrips(id,fromDate,toDate) {
        return Api.get(`/ETMSAgr/api/Dashboard/GetUpcomingTrips?facilityID=${id}&fromDate=${fromDate}&toDate=${toDate}&VendorID=`);
    },
    getCompletedTrips(id,fromDate,toDate) {
        return Api.get(`/ETMSAgr/api/Dashboard/GetCompletedTrips?facilityID=${id}&fromDate=${fromDate}&toDate=${toDate}&VendorID=`);
    },
    getTripStatusCount(id,fromDate,toDate) {
        return Api.get(`/ETMSAgr/api/Dashboard/GetTripStatusCount?facilityID=${id}&fromDate=${fromDate}&toDate=${toDate}&VendorID=`);
    },
    getVendorPerformance(id,fromDate,toDate) {
        return Api.get(`/ETMSAgr/api/Dashboard/GetVendorPerformance?facilityID=${id}&fromDate=${fromDate}&toDate=${toDate}&VendorID=`);
    },
    getUnAssignedTripsCount(id,fromDate,toDate) {
        return Api.get(`/ETMSAgr/api/Dashboard/GetUnAssignedTripsCount?facilityID=${id}&fromDate=${fromDate}&toDate=${toDate}&VendorID=`);
    },
    getAutoCancel(id,fromDate,toDate) {
        return Api.get(`ETMSAgr/api/Dashboard/GetAutoCancelledTrips?facilityID=${id}&fromDate=${fromDate}&toDate=${toDate}&VendorID=`);
    },
    getUnAssignedEmployees(id,fromDate,toDate) {
        return Api.get(`ETMSAgr/api/Dashboard/getUnAssignedEmployees?facilityID=${id}&fromDate=${fromDate}&toDate=${toDate}&VendorID=`);
    },
    getDashboardStatus(){
        return Api.get(`api/Dashboard/DashboardData`);  
    }
   
}